import { FC, useMemo } from 'react';

import { cx } from '../theme';

import { Container } from './Switch.styles';
import { SwitchProps } from './types';

/**
 * Switch Component
 */
export const Switch: FC<SwitchProps> = ({
  checked,
  disabled,
  thumb,
  thumbChecked,
  onChange,
}) => {
  const handlerChange = () => {
    if (!disabled) {
      onChange?.(!checked);
    }
  };
  const className = useMemo(
    () => cx('switch', { checked, disabled }),
    [checked, disabled]
  );

  const customThumb = useMemo(
    () => (checked ? thumbChecked || thumb : thumb),
    [checked, thumb, thumbChecked]
  );

  return (
    <Container className={className} role="button" onClick={handlerChange}>
      <div className="switch-thumbContainer">
        {customThumb || <div className="switch-thumb" />}
      </div>
    </Container>
  );
};
